













































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { BInputGroup, BOverlay, BInputGroupAppend, BIconCalendar, BForm, BFormGroup, BFormInput, BFormCheckbox, BContainer, BButton, BRow, BCol, BIconCloudUpload, BIconTrash, BFormTextarea, BFormInvalidFeedback, BFormSelectOption, BFormSelect, BFormDatepicker, BSpinner } from 'bootstrap-vue'
import Configuration from '@/types/Configuration';
import EntityReference from '@/types/EntityReference';
import Validator, { handleValidationErrors } from '@/types/Validator';
import DateTimePicker from '@/components/DateTimePicker.vue';
import DateTime from '@/types/DateTime';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-overlay': BOverlay,
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-form': BForm,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-invalid-feedback': BFormInvalidFeedback,
        'b-form-textarea': BFormTextarea,
        'b-form-checkbox': BFormCheckbox,
        'b-btn': BButton,
        'b-icon-cloud-upload': BIconCloudUpload,
        'b-icon-trash': BIconTrash,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-form-datepicker': BFormDatepicker,
        'b-icon-calendar': BIconCalendar,
        'date-picker': DateTimePicker,
        'b-input-group-append': BInputGroupAppend,
        'b-input-group': BInputGroup,
        'b-spinner': BSpinner
    }
})
export default class ProjectDetails extends Vue {
    @Prop() projectId!: string
    clients: EntityReference[] = [];
    projectManagers: EntityReference[] = [];
    locale = '';
    isBusy = true;
    clientId: string | null | undefined = null;
    projectManagerId: string | null | undefined = null;

    apiAccessToken = this.$store.state.apiAccessToken
    project: ProjectData = {
        id: '',
        sequenceId: 0,
        name: '',
        isActive: true,
        client: null,
        projectManager: null,
        identifier: '',
        description: '',
        start: null,
        end: null,
        responsiblePerson: '',
        contractInformation: ''
    }

    nameValidator: Validator = {
        isValid: null,
        errors: []
    };

    projectManagerValidator: Validator = {
        isValid: null,
        errors: []
    };

    clientValidator: Validator = {
        isValid: null,
        errors: []
    };

    identifierValidator: Validator = {
        isValid: null,
        errors: []
    };

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadProject(this.projectId);
        this.locale = this.$i18n.locale;
    }

    clearValidators() {
        this.nameValidator = {
            isValid: null,
            errors: []
        };

        this.projectManagerValidator = {
            isValid: null,
            errors: []
        };

        this.clientValidator = {
            isValid: null,
            errors: []
        };

        this.identifierValidator = {
            isValid: null,
            errors: []
        };
    }

    async loadProject(projectId: string) {
        if (projectId.length == 0) {
            this.loadProjectClients();
            this.loadProjectManagers();

            this.isBusy = false;

            return;
        }

        this.isBusy = true;

        DateTime.setLocale(this.$i18n.locale);

        try {
            const response = await AxiosService.request<ProjectData>({
                url: `projectsadministration/${projectId}`,
                method: 'GET'
            });

            this.project = response.data;
            this.clientId = this.project.client?.id;
            this.projectManagerId = this.project.projectManager?.id;
            this.loadProjectClients();
            this.loadProjectManagers();
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async loadProjectClients() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `clientslookup`,
                method: 'GET'
            });

            this.clients = response.data.records ?? [];
            if (this.project && this.clientId) {
                if (this.clients.length == 0 || !this.clients.find(c => c.id == this.clientId)) {
                    this.clients.push(this.project.client as EntityReference);
                }
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadProjectManagers() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `userslookup`,
                method: 'GET'
            });

            this.projectManagers = response.data.records ?? [];
            if (this.project && this.projectManagerId) {
                if (this.projectManagers.length == 0 || !this.projectManagers.find(pm => pm.id == this.projectManagerId)) {
                    this.projectManagers.push(this.project.projectManager as EntityReference);
                }
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async onSubmit(e: Event) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.isBusy = true;

        this.clearValidators();

        this.project.client = {
            id: this.clientId as string,
            name: ''
        };

        this.project.projectManager = {
            id: this.projectManagerId as string,
            name: ''
        }

        try {
            await AxiosService.request<ClientData>({
                url: `projectsadministration`,
                method: 'POST',
                data: this.project
            });

            this.$root.$bvToast.toast(this.$t('toaster.projectSaved') as string, {
                title: this.$t('toaster.saveProjectTitle') as string,
                autoHideDelay: Configuration.ToasterAutoHideDelay,
                appendToast: true,
                variant: Configuration.ToasterVariantSuccess,
                toaster: Configuration.ToasterPosition
            });
            this.$emit('project-saved', true);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    case 400:
                        handleValidationErrors(this, error.response.data.errors.Name, this.nameValidator);
                        handleValidationErrors(this, error.response.data.errors['ProjectManager.Id'], this.projectManagerValidator);
                        handleValidationErrors(this, error.response.data.errors['Client.Id'], this.clientValidator);
                        handleValidationErrors(this, error.response.data.errors.Identifier, this.identifierValidator);
                        return;
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    async deleteProject() {
        try {
            const response = await AxiosService.request({
                url: `projectsadministration/candelete/${this.projectId}`,
                method: 'GET'
            });

            const canDelete = response.data.canDelete;

            if (!canDelete) {
                this.$bvModal.msgBoxOk(
                    this.$t('modal.deniedProjectDeleteMessage', { projectName: this.project.name }) as string, {
                        title: this.$t('modal.deniedProjectDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.closeModal') as string
                    }
                );
                return;
            }

            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmProjectDeleteMessage', { projectName: this.project.name }) as string, {
                title: this.$t('modal.confirmProjectDeleteTitle') as string,
                    centered: true,
                    buttonSize: 'sm',
                    okTitle: this.$t('modal.confirmOkTitle') as string,
                    cancelTitle: this.$t('modal.confirmCancelTitle') as string
                })
                .then(value => {
                    if (value) {
                        this.isBusy = true;

                        try {
                            AxiosService.request < boolean > ({
                                url: `projectsadministration?id=${this.projectId}`,
                                method: 'DELETE'
                            });

                            this.$root.$bvToast.toast(this.$t('toaster.projectDeleted', { projectName: this.project.name }) as string, {
                                title: this.$t('toaster.deleteProjectTitle') as string,
                                autoHideDelay: Configuration.ToasterAutoHideDelay,
                                appendToast: true,
                                variant: Configuration.ToasterVariantSuccess,
                                toaster: Configuration.ToasterPosition
                            });
                            this.$emit('project-deleted', true);
                        }
                        catch (error) {
                            if (error.response) {
                                switch (error.response.status) {
                                    case 404:
                                        return this.$router.push(`/${i18n.locale}/notfound`);
                                    case 403:
                                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                                    default:
                                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                }
                            }
                        }
                    }
                })
                .finally(() => {
                    this.isBusy = false;
                })
                .catch(error => {
                    console.error(error);
                });
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    onChangeStartDate(e: string) {
        this.project.start = e;
    }

    onChangeEndDate(e: string) {
        this.project.end = e;
    }
}

interface ProjectData {
    id: string;
    sequenceId: number;
    name: string;
    projectManager: EntityReference | null;
    client: EntityReference | null;
    isActive: boolean;
    identifier: string;
    description: string;
    start: string | null;
    end: string | null;
    responsiblePerson: string;
    contractInformation: string;
}

interface EntityList {
    records: EntityReference[];
}
